// TextField — wrapper sobre .m-field + .m-label + .m-input do Maestro.
// Estrutura HTML segue o padrão oficial:
//   <label class="m-field">
//     <span class="m-label">E-mail</span>
//     <div class="m-input"><input ...></div>
//     <span class="m-help">dica</span>  (ou .m-help--error)
//   </label>

import { InputHTMLAttributes, forwardRef, useId } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  unit?: string;
}

export const TextField = forwardRef<HTMLInputElement, Props>(function TextField(
  { label, error, hint, unit, id, className, ...rest },
  ref,
) {
  const fallbackId = useId();
  const inputId = id || `tf-${fallbackId}`;
  const describedBy = error ? `${inputId}-err` : hint ? `${inputId}-hint` : undefined;
  const wrapCls = ['m-input', error ? 'm-input--invalid' : ''].filter(Boolean).join(' ');
  return (
    <label className={`m-field ${className || ''}`} htmlFor={inputId}>
      {label && <span className="m-label">{label}</span>}
      <span className={wrapCls}>
        <input
          {...rest}
          id={inputId}
          ref={ref}
          aria-invalid={!!error || undefined}
          aria-describedby={describedBy}
        />
        {unit && <span className="m-unit">{unit}</span>}
      </span>
      {error ? (
        <span id={`${inputId}-err`} className="m-help m-help--error">
          {error}
        </span>
      ) : hint ? (
        <span id={`${inputId}-hint`} className="m-help">
          {hint}
        </span>
      ) : null}
    </label>
  );
});
